import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'rial',
    standalone: true
})
export class RialPipe implements PipeTransform {

  transform(value: number | string): number {
    if(!value) return 0;
    return Number(value) / 10;
  }

}
